import Layers from "slotworks/graphics/layers/layers";
import BackgroundBlockerControl from "slotworks/smart-ui/controls/background-blocker-control";
import BackgroundCloseControl from "slotworks/smart-ui/controls/background-close-control";
import CloseButtonControl from "slotworks/smart-ui/controls/button/close-button-control";
import HomeButtonControl from "slotworks/smart-ui/controls/button/home-button-control";
import MaxBetButtonControl from "slotworks/smart-ui/controls/button/max-bet-button-control";
import UKGCAutoplayStartButtonControl from "slotworks/smart-ui/controls/button/ukgc-autoplay-start-button-control";
import { Control } from "slotworks/smart-ui/controls/control";
import GambleControl from "slotworks/smart-ui/controls/gamble/gamble-control";
import PaytableControl from "slotworks/smart-ui/controls/paytable-control";
import AutoplayRadioControl from "slotworks/smart-ui/controls/radio/autoplay-radio-control";
import LossLimitRadioControl from "slotworks/smart-ui/controls/radio/loss-limit-radio-control";
import SingleWinLimitRadioControl from "slotworks/smart-ui/controls/radio/single-win-limit-radio-control";
import CreditSizeSliderControl from "slotworks/smart-ui/controls/slider/credit-size-slider-control";
import SingleWinLossLimitSliderControl from "slotworks/smart-ui/controls/slider/single-win-loss-limit-slider-control";
import TotalLossLimitSliderControl from "slotworks/smart-ui/controls/slider/total-loss-limit-slider-control";
import TotalWinLossLimitSliderControl from "slotworks/smart-ui/controls/slider/total-win-loss-limit-slider-control";
import CancelAutoControl from "slotworks/smart-ui/controls/spin/cancel-auto-control";
import SkipAreaControl from "slotworks/smart-ui/controls/spin/skip-area-control";
import SpinControl from "slotworks/smart-ui/controls/spin/spin-control";
import FlashingSpriteControl from "slotworks/smart-ui/controls/sprite/flashing-sprite-control";
import CreditSizeStepperControl from "slotworks/smart-ui/controls/stepper/credit-size-stepper-control";
import TotalStakeStepperControl from "slotworks/smart-ui/controls/stepper/total-stake-stepper-control";
import AutoplaysTextControl from "slotworks/smart-ui/controls/text/autoplays-text-control";
import CreditSizeTextControl from "slotworks/smart-ui/controls/text/credit-size-text-control";
import TotalCreditsTextControl from "slotworks/smart-ui/controls/text/total-credits-text-control";
import TotalStakeTextControl from "slotworks/smart-ui/controls/text/total-stake-text-control";
import CustomAutoplayCountToggleControl from "slotworks/smart-ui/controls/toggle/custom-autoplay-count-toggle-control";
import CustomAutoplayLossLimitToggleControl from "slotworks/smart-ui/controls/toggle/custom-autoplay-loss-limit-toggle-control";
import CustomAutoplaySingleWinLimitToggleControl from "slotworks/smart-ui/controls/toggle/custom-autoplay-single-win-limit-toggle-control";
import DisplayCreditsToggleControl from "slotworks/smart-ui/controls/toggle/display-credits-toggle-control";
import MusicToggleControl from "slotworks/smart-ui/controls/toggle/music-toggle-control";
import SoundToggleControl from "slotworks/smart-ui/controls/toggle/sound-toggle-control";
import SoundfxToggleControl from "slotworks/smart-ui/controls/toggle/soundfx-toggle-control";
import StopOnFeatureWinToggleControl from "slotworks/smart-ui/controls/toggle/stop-on-feature-win-toggle-control";
import StopOnWinToggleControl from "slotworks/smart-ui/controls/toggle/stop-on-win-toggle-control";
import TurboToggleControl from "slotworks/smart-ui/controls/toggle/turbo-toggle-control";
import AutoplayCountNoLimitButtonControl from "./controls/button/autoplay-count-no-limit-button-control";
import ClearAutoplayButtonControl from "./controls/button/clear-autoplay-button-control";
import CloseAutoplayButtonControl from "./controls/button/close-autoplay-button-control";
import CustomAutoplayCountButtonControl from "./controls/button/custom-autoplay-count-button-control";
import CustomAutoplayLossLimitCountButtonControl from "./controls/button/custom-autoplay-loss-limit-count-button-control";
import CustomAutoplaySingleWinLimitCountButtonControl from "./controls/button/custom-autoplay-single-win-limit-count-button-control";
import CustomAutoplayCountInputControl from "./controls/input/custom-autoplay-count-input-control";
import CustomLossLimitInputControl from "./controls/input/custom-loss-limit-input-control";
import CustomSingleWinLimitInputControl from "./controls/input/custom-single-win-limit-input-control";
import TotalCreditsRadioControl from "./controls/radio/total-credits-radio-control";
import TotalStakeRadioControl from "./controls/radio/total-stake-radio-control";
import VolumeSliderControl from "./controls/slider/volume-slider-control";
import { HoldSpinControl } from "./controls/spin/hold-spin-control";
import AutoplayCountStepperControl from "./controls/stepper/autoplay-count-stepper-control";
import AutoplayLossLimitStepperControl from "./controls/stepper/autoplay-loss-limit-stepper-control";
import AutoplaySingleWinLimitStepperControl from "./controls/stepper/autoplay-single-win-limit-stepper-control";
import AutoplayReadyMessageTextControl from "./controls/text/autoplay-ready-message-text-control";
import SimpleSoundToggleControl from "./controls/toggle/simple-sound-toggle-control";

export default class ControlList<T extends Control> {
    public static CREDIT_SIZE_SLIDER = new ControlList<CreditSizeSliderControl>(CreditSizeSliderControl, "credit_size_slider", ["_handle", "_fill", "_track"]);
    public static SINGLE_WIN_LOSS_LIMIT_SLIDER = new ControlList<SingleWinLossLimitSliderControl>
    (SingleWinLossLimitSliderControl, "single_win_limit_slider", ["_handle", "_fill", "_track"]);
    public static TOTAL_LOSS_LIMIT_SLIDER = new ControlList<TotalLossLimitSliderControl>(TotalLossLimitSliderControl, "total_loss_limit_slider", ["_handle", "_fill", "_track"]);
    public static TOTAL_LIMIT_SLIDER = new ControlList<TotalWinLossLimitSliderControl>(TotalWinLossLimitSliderControl, "total_win_limit_slider", ["_handle", "_fill", "_track"]);
    public static VOLUME_SLIDER = new ControlList<VolumeSliderControl>(VolumeSliderControl, "volume_slider", ["_handle", "_fill", "_track"]);
    public static DOM_VOLUME_SLIDER = new ControlList<VolumeSliderControl>(VolumeSliderControl, "volume_slider");

    public static AUTOPLAY_RADIO = new ControlList<AutoplayRadioControl>(AutoplayRadioControl, "autoplay_radio", ["_1"]);
    public static TOTAL_CREDITS_RADIO = new ControlList<TotalCreditsRadioControl>(TotalCreditsRadioControl, "total_credits_radio", ["_1"]);
    public static TOTAL_STAKE_RADIO = new ControlList<TotalStakeRadioControl>(TotalStakeRadioControl, "total_stake_radio", ["_1"]);
    public static LOSS_LIMIT_RADIO = new ControlList<LossLimitRadioControl>(LossLimitRadioControl, "loss_limit_radio", ["_1"]);
    public static SINGLE_WIN_LIMIT_RADIO = new ControlList<SingleWinLimitRadioControl>(SingleWinLimitRadioControl, "single_win_limit_radio", ["_1"]);

    public static AUTOPLAY_COUNT_STEPPER = new ControlList<AutoplayCountStepperControl>(AutoplayCountStepperControl, "autoplay_count_stepper", ["_up", "_down", "_value"]);
    public static AUTOPLAY_LOSS_LIMIT_STEPPER = new ControlList<AutoplayLossLimitStepperControl>(AutoplayLossLimitStepperControl,
        "autoplay_loss_limit_stepper", ["_up", "_down", "_value"]);
    public static AUTOPLAY_SINGLE_WIN_LIMIT_STEPPER = new ControlList<AutoplaySingleWinLimitStepperControl>(AutoplaySingleWinLimitStepperControl,
        "autoplay_single_win_limit_stepper", ["_up", "_down", "_value"]);
    public static AUTOPLAY_COUNT_NO_LIMIT_BUTTON = new ControlList<AutoplayCountNoLimitButtonControl>(AutoplayCountNoLimitButtonControl, "autoplay_count_no_limit");

    public static CREDIT_SIZE_STEPPER = new ControlList<CreditSizeStepperControl>(CreditSizeStepperControl, "credit_size_stepper", ["_up", "_down", "_value"]);
    public static TOTAL_STAKE_STEPPER = new ControlList<TotalStakeStepperControl>(TotalStakeStepperControl, "total_stake_stepper", ["_up", "_down", "_value"]);

    public static TOTAL_CREDITS_TEXT = new ControlList<TotalCreditsTextControl>(TotalCreditsTextControl, "total_in_credits");
    public static TOTAL_STAKE_TEXT = new ControlList<TotalStakeTextControl>(TotalStakeTextControl, "total_stake_text");
    public static CREDIT_SIZE_TEXT = new ControlList<CreditSizeTextControl>(CreditSizeTextControl, "credit_size_text");
    public static AUTOPLAY_COUNT = new ControlList<AutoplaysTextControl>(AutoplaysTextControl, "autoplays_count");
    public static AUTOPLAY_READY_MESSAGE_TEXT = new ControlList<AutoplayReadyMessageTextControl>(AutoplayReadyMessageTextControl, "autoplay_ready_message");

    public static CLOSE_BUTTON = new ControlList<CloseButtonControl>(CloseButtonControl, "close");
    public static AUTOPLAY_CLOSE_BUTTON = new ControlList<CloseAutoplayButtonControl>(CloseAutoplayButtonControl, "autoplay_close");
    public static HOME_BUTTON = new ControlList<HomeButtonControl>(HomeButtonControl, "home");
    public static MAX_BET_BUTTON = new ControlList<MaxBetButtonControl>(MaxBetButtonControl, "max_bet");
    public static CLEAR_AUTOPLAY_BUTTON = new ControlList<ClearAutoplayButtonControl>(ClearAutoplayButtonControl, "clear_autoplay");

    public static BACKGROUND_CLOSE = new ControlList<BackgroundCloseControl>(BackgroundCloseControl, "background_close");
    // Cover and blocker are synonyms
    public static BACKGROUND_BLOCKER = new ControlList<BackgroundBlockerControl>(BackgroundBlockerControl, "background_blocker");
    public static BACKGROUND_COVER = new ControlList<BackgroundBlockerControl>(BackgroundBlockerControl, "cover");

    public static PAYTABLE = new ControlList<PaytableControl>(PaytableControl, "paytable", ["_previous", "_next"]);

    public static MUSIC_TOGGLE = new ControlList<MusicToggleControl>(MusicToggleControl, "music_toggle", ["_on", "_off"]);
    public static SOUNDFX_TOGGLE = new ControlList<SoundfxToggleControl>(SoundfxToggleControl, "soundfx_toggle", ["_on", "_off"]);
    public static SOUND_TOGGLE = new ControlList<SoundToggleControl>(SoundToggleControl, "sound_toggle", ["_on", "_off"]);
    public static SIMPLE_SOUND_TOGGLE = new ControlList<SimpleSoundToggleControl>(SimpleSoundToggleControl, "simple_sound_toggle", ["_on", "_off"]);

    public static CUSTOM_AUTOPLAY_COUNT_TOGGLE = new ControlList<CustomAutoplayCountToggleControl>(CustomAutoplayCountToggleControl, "custom_count_toggle", ["_on", "_off"]);
    public static CUSTOM_AUTOPLAY_LOSS_LIMIT_TOGGLE = new ControlList<CustomAutoplayLossLimitToggleControl>(CustomAutoplayLossLimitToggleControl,
        "custom_loss_limit_toggle", ["_on", "_off"]);
    public static CUSTOM_AUTOPLAY_SINGLE_WIN_LIMIT_TOGGLE = new ControlList<CustomAutoplaySingleWinLimitToggleControl>(CustomAutoplaySingleWinLimitToggleControl,
        "custom_single_win_limit_toggle", ["_on", "_off"]);

    public static CUSTOM_AUTOPLAY_COUNT_BUTTON = new ControlList<CustomAutoplayCountButtonControl>
    (CustomAutoplayCountButtonControl, "autoplay_custom_count_button");
    public static CUSTOM_AUTOPLAY_LOSS_LIMIT_COUNT_BUTTON = new ControlList<CustomAutoplayLossLimitCountButtonControl>
    (CustomAutoplayLossLimitCountButtonControl, "autoplay_loss_limit_button");
    public static CUSTOM_AUTOPLAY_SINGLE_WIN_COUNT_BUTTON = new ControlList<CustomAutoplaySingleWinLimitCountButtonControl>
    (CustomAutoplaySingleWinLimitCountButtonControl, "autoplay_single_win_limit_button");

    public static DOM_MUSIC_TOGGLE = new ControlList<MusicToggleControl>(MusicToggleControl, "music_toggle");
    public static DOM_SOUNDFX_TOGGLE = new ControlList<SoundfxToggleControl>(SoundfxToggleControl, "soundfx_toggle");
    public static DOM_TURBO_TOGGLE = new ControlList<TurboToggleControl>(TurboToggleControl, "turbo_toggle");
    public static DOM_SIMPLE_SOUND_TOGGLE = new ControlList<SimpleSoundToggleControl>(SimpleSoundToggleControl, "simple_sound_toggle");

    public static DISPLAY_CREDITS_TOGGLE = new ControlList<DisplayCreditsToggleControl>(DisplayCreditsToggleControl, "display_credits_toggle", ["_on", "_off"]);
    public static STOP_ON_WIN_TOGGLE = new ControlList<StopOnWinToggleControl>(StopOnWinToggleControl, "stop_on_any_win_toggle", ["_on", "_off"]);
    public static STOP_ON_FEATURE_WIN_TOGGLE = new ControlList<StopOnFeatureWinToggleControl>(StopOnFeatureWinToggleControl, "stop_on_feature_win_toggle", ["_on", "_off"]);
    public static TURBO_TOGGLE = new ControlList<TurboToggleControl>(TurboToggleControl, "turbo_toggle", ["_on", "_off"]);

    public static LOSS_LIMIT_INPUT = new ControlList<CustomLossLimitInputControl>(CustomLossLimitInputControl, "loss_limit");
    public static SINGLE_WIN_LIMIT_INPUT = new ControlList<CustomSingleWinLimitInputControl>(CustomSingleWinLimitInputControl, "single_win_limit");
    public static SPIN_COUNT_INPUT = new ControlList<CustomAutoplayCountInputControl>(CustomAutoplayCountInputControl, "spin_count");

    public static UKGC_AUTOPLAY_START_BUTTON = new ControlList<UKGCAutoplayStartButtonControl>(UKGCAutoplayStartButtonControl, "ukgc_autoplay_start_button");

    public static UKGC_LOSS_LIMIT_FLASHING_SPRITE = new ControlList<FlashingSpriteControl>(FlashingSpriteControl, "ukgc_loss_limit_flashing_sprite");

    public static SPIN = new ControlList<SpinControl>(SpinControl, "spin_button");
    public static GAMBLE = new ControlList<GambleControl>(GambleControl, "gamble", [ "_button", "_collect" ]);
    public static GAMBLE_UI = new ControlList<GambleControl>(GambleControl, "gamble", [ "_collect" ]);
    public static HOLD_SPIN = new ControlList<HoldSpinControl>(HoldSpinControl, "hold_spin_button");
    public static SKIP_AREA = new ControlList<SkipAreaControl>(SkipAreaControl, "skipArea");
    public static AUTO_STOP = new ControlList<CancelAutoControl>(CancelAutoControl, "auto_stop");

    public static TOTAL_CREDITS_MULTI_DEPRECATED = new ControlList<TotalCreditsRadioControl>(TotalCreditsRadioControl, "total_credits_multi", ["_1"]);
    public static AUTOPLAY_MULTI_DEPRECATED = new ControlList<AutoplayRadioControl>(AutoplayRadioControl, "autoplay_multi", ["_1"]);

    public static addControlList(control: ControlList<any>) {
        ControlList.ALL_CONTROLS.push(control);
    }

    public static addControlLists(controls: Array<ControlList<any>>) {
        ControlList.ALL_CONTROLS.push.apply(ControlList.ALL_CONTROLS, controls);
    }

    public static getAllControls(): Array<ControlList<any>> {
        return ControlList.ALL_CONTROLS;
    }

    public static removeControl(control: ControlList<any>) {
        const index = ControlList.ALL_CONTROLS.indexOf(control);
        if (index > -1) {
            ControlList.ALL_CONTROLS.splice(ControlList.ALL_CONTROLS.indexOf(control), 1);
        }
    }

    private static ALL_CONTROLS = [
        ControlList.AUTOPLAY_MULTI_DEPRECATED,
        ControlList.TOTAL_CREDITS_MULTI_DEPRECATED,
        ControlList.TOTAL_CREDITS_RADIO,
        ControlList.TOTAL_STAKE_RADIO,
        ControlList.TOTAL_STAKE_STEPPER,
        ControlList.TOTAL_CREDITS_TEXT,
        ControlList.TOTAL_STAKE_TEXT,
        ControlList.CREDIT_SIZE_TEXT,
        ControlList.AUTOPLAY_COUNT,
        ControlList.HOME_BUTTON,
        ControlList.DISPLAY_CREDITS_TOGGLE,
        ControlList.LOSS_LIMIT_INPUT,
        ControlList.SINGLE_WIN_LIMIT_INPUT,
        ControlList.SPIN_COUNT_INPUT,
        ControlList.STOP_ON_WIN_TOGGLE,
        ControlList.STOP_ON_FEATURE_WIN_TOGGLE,
        ControlList.CLOSE_BUTTON,
        ControlList.AUTOPLAY_CLOSE_BUTTON,
        ControlList.CLEAR_AUTOPLAY_BUTTON,
        ControlList.CUSTOM_AUTOPLAY_COUNT_TOGGLE,
        ControlList.CUSTOM_AUTOPLAY_LOSS_LIMIT_TOGGLE,
        ControlList.CUSTOM_AUTOPLAY_SINGLE_WIN_LIMIT_TOGGLE,
        ControlList.CUSTOM_AUTOPLAY_COUNT_BUTTON,
        ControlList.CUSTOM_AUTOPLAY_LOSS_LIMIT_COUNT_BUTTON,
        ControlList.CUSTOM_AUTOPLAY_SINGLE_WIN_COUNT_BUTTON,
        ControlList.MAX_BET_BUTTON,
        ControlList.PAYTABLE,
        ControlList.BACKGROUND_CLOSE,
        ControlList.CREDIT_SIZE_SLIDER,
        ControlList.CREDIT_SIZE_STEPPER,
        ControlList.MUSIC_TOGGLE,
        ControlList.SOUNDFX_TOGGLE,
        ControlList.SOUND_TOGGLE,
        ControlList.SINGLE_WIN_LOSS_LIMIT_SLIDER,
        ControlList.TOTAL_LOSS_LIMIT_SLIDER,
        ControlList.TOTAL_LIMIT_SLIDER,
        ControlList.VOLUME_SLIDER,
        ControlList.UKGC_AUTOPLAY_START_BUTTON,
        ControlList.UKGC_LOSS_LIMIT_FLASHING_SPRITE,
        ControlList.SPIN,
        ControlList.GAMBLE,
        ControlList.GAMBLE_UI,
        ControlList.HOLD_SPIN,
        ControlList.SKIP_AREA,
        ControlList.AUTO_STOP,
        ControlList.BACKGROUND_BLOCKER,
        ControlList.BACKGROUND_COVER,
        ControlList.LOSS_LIMIT_RADIO,
        ControlList.SINGLE_WIN_LIMIT_RADIO,
        ControlList.AUTOPLAY_RADIO,
        ControlList.TURBO_TOGGLE,
        ControlList.AUTOPLAY_COUNT_STEPPER,
        ControlList.AUTOPLAY_LOSS_LIMIT_STEPPER,
        ControlList.AUTOPLAY_SINGLE_WIN_LIMIT_STEPPER,
        ControlList.AUTOPLAY_COUNT_NO_LIMIT_BUTTON,
        ControlList.AUTOPLAY_READY_MESSAGE_TEXT,
        ControlList.SIMPLE_SOUND_TOGGLE,
        ControlList.DOM_MUSIC_TOGGLE,
        ControlList.DOM_SIMPLE_SOUND_TOGGLE,
        ControlList.DOM_SOUNDFX_TOGGLE,
        ControlList.DOM_TURBO_TOGGLE,
        ControlList.DOM_VOLUME_SLIDER
    ];

    constructor(public type: new () => T, public assetName: string, public assetExtensions?: string[]) {
    }

    public getNewType(): T {
        return new this.type();
    }

    public getName(): string {
        return (this as any).constructor.name + " " + this.getAllAssetNames();
    }

    public layerHasThisControl(layer: Layers): boolean {
        const assets = this.getAllAssetNames();

        return layer.hasAssetOfName(assets[0]);
    }

    public getAllAssetNames(): string[] {
        if (this.assetExtensions) {
            return this.assetExtensions.map((i) => this.assetName + i);
        }

        return [this.assetName];
    }
}
